import { render, staticRenderFns } from "./ImprintFooter.vue?vue&type=template&id=7f4cead4&scoped=true&"
import script from "./ImprintFooter.vue?vue&type=script&lang=js&"
export * from "./ImprintFooter.vue?vue&type=script&lang=js&"
import style0 from "./ImprintFooter.vue?vue&type=style&index=0&id=7f4cead4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cead4",
  null
  
)

export default component.exports